<footer class="footer">
  <div class="footer-inner">

    <div class="footer-grid">
      <!-- Marca: logo sobre el mismo rombo del menú superior -->
      <section class="footer-brand" aria-label="Consultorio Bien-Estar">
        <div class="footer-mark" aria-hidden="true">
          <span class="footer-diamond"></span>
          <img class="footer-mark-logo" src="assets/images/logo-128.webp" width="128" height="128" alt="" loading="lazy">
        </div>

        <p class="footer-name">Bienestar con Natalia Güechá</p>
        <p class="footer-role">Psicóloga clínica · Bogotá, Colombia</p>
        <p class="footer-lead">Terapia psicológica online en español, individual y de pareja, para Latinoamérica y España.</p>

        <ul class="footer-social" aria-label="Redes sociales">
          <li *ngFor="let social of socialLinks">
            <a [href]="social.url" target="_blank" rel="noopener" [attr.aria-label]="social.label" [title]="social.label">
              <i [class]="social.icon" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </section>

      <!-- Secciones de la portada -->
      <nav class="footer-col" aria-labelledby="footer-nav-title">
        <h2 class="footer-heading" id="footer-nav-title">Navegación</h2>
        <ul class="footer-links">
          <li *ngFor="let item of navItems">
            <a [href]="'/#' + item.id" (click)="goToSection(item.id, $event)">{{ item.name }}</a>
          </li>
        </ul>
      </nav>

      <!-- NAP (nombre, dirección, teléfono) y horario en texto: señal de SEO local
           coherente con el JSON-LD de index.html -->
      <section class="footer-col" aria-labelledby="footer-contact-title">
        <h2 class="footer-heading" id="footer-contact-title">Contacto</h2>
        <address class="footer-nap">
          <p>
            <i class="fas fa-phone" aria-hidden="true"></i>
            <a href="tel:+573104671284">+57 310 4671284</a>
          </p>
          <p>
            <i class="fas fa-envelope" aria-hidden="true"></i>
            <a href="mailto:consultas@bienestarconnataliaguecha.com">consultas@<wbr>bienestarconnataliaguecha.com</a>
          </p>
          <p>
            <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
            <span>Bogotá, Colombia · Atención online</span>
          </p>
          <p>
            <i class="far fa-clock" aria-hidden="true"></i>
            <span>Lunes a domingo, 9:00 – 20:00<br><small>(hora de Bogotá)</small></span>
          </p>
        </address>
      </section>
    </div>

    <!-- Aviso de urgencias (mismo texto que la FAQ y el contenido de respaldo) -->
    <p class="footer-notice">
      <i class="fas fa-circle-info" aria-hidden="true"></i>
      <span>Este sitio no atiende urgencias. Si estás en riesgo vital, llama a la línea de emergencias de tu país
        (123 en Colombia, 112 en España) o acude a urgencias.</span>
    </p>

    <div class="footer-bottom">
      <p class="footer-copy">© {{ year }} Bienestar con Natalia Güechá. Todos los derechos reservados.</p>

      <!-- Firma de PockSite: "By" + logo, igual que en la versión anterior -->
      <a href="https://www.pocksite.com" target="_blank" rel="noopener" class="footer-credit">
        By
        <img src="assets/images/LogoBlanco.svg" alt="PockSite" class="footer-credit-logo">
      </a>
    </div>

  </div>
</footer>
